import React from 'react';
import { Outlet } from 'react-router-dom';

const Details = () => <Outlet />;

export default Details;
